import React from 'react';
import { useState, useContext } from 'react';
import { Suspense, lazy } from 'react';
import { 
  //BrowserRouter as Router, 
  Routes,
  Route, 
  useLocation,
  useNavigate,
} from 'react-router-dom';

import ShoppingCart from './components/ShoppingCart';
import CatalogCategories from './components/CatalogCategories';
import Category from './components/Category';
import Profile from './components/Profile';
import Product from './components/Product';
import Tickets from './components/Tickets';
//import Order from './components/Order';
//import FormRenderer from './components/FormRenderer';
import TasksList from './components/TasksList';
import TasksCalendar from './components/TasksCalendar';
import Header from './components/Header';
import SideBar from './components/Sidebar';
import SendContract from './components/SendContract';
import TicketCreate from './components/TicketCreate';
import TicketUpdate from './components/TicketUpdate';

//import axios from 'axios';
import axios_api from './Api';
import { API_URL, AUTH_TOKEN } from './Context';
import FormPage from './components/FormRenderer/FormPage';


// JS code splitting
const Order = lazy(() => import('./components/Order'));
const FormRenderer = lazy(() => import('./components/FormRenderer/FormRenderer'));



function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    // "document.documentElement.scrollTo" is the magic for React Router Dom v6
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional if you want to skip the scrolling animation
    });
  }, [pathname]);

  return null;
}


function ProtectedPages({setAuthToken, appUserName, setAppUserName}) {

  const [shoppingCart, setShoppingCart] = useState([]);
  const [order, setOrder] = useState([]);
  const [categories, setCategories] = useState([]);
  const [goodsList, setGoodsList] = useState([]);
  const [userYears, setUserYears] = useState([]);
  const [currentYear, setCurrentYear] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();

  if(!selectedYear) {
    let year = localStorage.getItem('selectedYear');
    if (year) {
      //console.log(year);
      setSelectedYear(year);
    } 
  }
  

  React.useEffect(() => {

    let years = axios_api.get(api_url + '/years', {
      headers: {"Authorization": token}
    });
    
    years.then(
      (result) => {
        let apiReturnedYears = result.data;
        let selectedYearGetParameter = null
        setUserYears(apiReturnedYears.user_years);
        setCurrentYear(apiReturnedYears.current_year);

        if (!selectedYear) {
          localStorage.setItem('selectedYear', apiReturnedYears.user_years[0]);
          setSelectedYear(apiReturnedYears.user_years[0]);
          selectedYearGetParameter = apiReturnedYears.user_years[0] // Нужна дополнительная переменная, чтобы у GET запросов Order и ShoppingCart всегда был установлен параметр. setSelectedYear может не успеть сработать
          console.log('no saved current year. Setting ' + apiReturnedYears.user_years[0] + ' as one');
        } else {
          selectedYearGetParameter = selectedYear 
        }
        console.log(apiReturnedYears);


        let order = axios_api.get(api_url + '/order', {
          headers: {"Authorization": token},
          params: {"year": selectedYearGetParameter}
        });
    
        order.then(
          (result) => {
            let apiReturnedOrder = result.data;
            setOrder(apiReturnedOrder);
          },
          (error) => {
            console.log(error)
            setOrder([]);
          }
        );


        let shoppingCart = axios_api.get(api_url + '/shopping_cart', {
          headers: {"Authorization": token},
          params: {"year": selectedYearGetParameter}
        });
    
        shoppingCart.then(
          (result) => {
            let apiReturnedShoppingCart = result.data
            setShoppingCart(apiReturnedShoppingCart);
    
            let categories = axios_api.get(api_url + '/categories', {
              headers: {"Authorization": token}
            });
            let priceList = axios_api.get(api_url + '/prices', {
              headers: {"Authorization": token},
              params: {"year": selectedYearGetParameter}
            });
    
            categories.then(
              (result) => {
                let apiReturnedCategories = Object()
                apiReturnedCategories = result.data  
                setCategories(apiReturnedCategories);
              },
              (error) => {console.log(error)}
            );
    
            priceList.then(
              (result) => {
                for (let elem in result.data) {
                  result.data[elem].selected = false;
                  let added_products = apiReturnedShoppingCart.added_products;
                  let index = added_products.findIndex(item => item.nomenclature_price === result.data[elem].id);
                  if (index >= 0) {
                    result.data[elem].selected = true;
                  } 
                }  
                let apiReturnedGoods = result.data;
                //console.log(apiReturnedGoods)
                setGoodsList(apiReturnedGoods);
              },
              (error) => {console.log(error)}
            );
          },
          (error) => {console.log(error)}
        )

      },
      (error) => {
        console.log(error)
        setUserYears([]);
      }
    );
  }, []);

 
  function SyncProfile(userProfileNext){
    let profileObject = userProfileNext

    axios_api.post(api_url + `/profile`, profileObject, {
      headers: {"Authorization": token}
    })
    .then(
      (result) => {
        //console.log("sending ShoppingCart");
      },
      (error) => {console.log(error)}
    );
  }

  function SyncShoppingCart(shoppingCartNext){
    let shoppingCartObject = shoppingCartNext

    axios_api.post(api_url + `/shopping_cart`,  shoppingCartObject, {
      headers: {"Authorization": token}
    })
    .then(
      (result) => {
        //console.log("sending ShoppingCart");
      },
      (error) => {
        console.log(error.response); 
      }
    );
  }


  function AddProductButtonClick(id){
    const goodsListNext = structuredClone(goodsList);
    const shoppingCartNext = structuredClone(shoppingCart);

    let index = goodsListNext.findIndex(x => x.id === id);
    goodsListNext[index].selected = true;

    let index_2 = shoppingCartNext.added_products.findIndex(item => item.id === id)
    if (index_2 >= 0) {
      console.log("Product is already in shoppingcart");
    } else {
      shoppingCartNext.added_products.push({"nomenclature_price": id, "quantity": 1});
      setShoppingCart(shoppingCartNext);
      setGoodsList(goodsListNext);
    }

    SyncShoppingCart(shoppingCartNext);
  } 


  function RemoveProductButtonClick(id){
    const shoppingCartNext = structuredClone(shoppingCart);
    const goodsListNext = structuredClone(goodsList);

    let index_2 = shoppingCartNext.added_products.findIndex(item => item.nomenclature_price === id);
    if (index_2 >= 0) {
        shoppingCartNext.added_products.splice(index_2, 1);
        let index_1 = goodsListNext.findIndex(x => x.id === id); 
        goodsListNext[index_1].selected = false;
        setShoppingCart(shoppingCartNext);
        setGoodsList(goodsListNext);
        SyncShoppingCart(shoppingCartNext);
    } else {
      console.log("Product is not in shoppingcart");
    }
  }


  function IncreaseProductCountButtonClick(id) {
    const shoppingCartNext = structuredClone(shoppingCart);
    const goodsListNext = structuredClone(goodsList);

    let index = shoppingCartNext.added_products.findIndex(item => item.nomenclature_price === id);
    if (index >= 0) {
        shoppingCartNext.added_products[index].quantity += 1;
        setShoppingCart(shoppingCartNext);
        setGoodsList(goodsListNext);
        SyncShoppingCart(shoppingCartNext);
    } else {
      console.log("Product is not in shoppingcart");
    }
  }


  function DecreaseProductCountButtonClick(id) {
    const shoppingCartNext = structuredClone(shoppingCart);
    const goodsListNext = structuredClone(goodsList);

    let index = shoppingCartNext.added_products.findIndex(item => item.nomenclature_price === id);
    if (index >= 0) {
      if (shoppingCartNext.added_products[index].quantity > 1) {
        shoppingCartNext.added_products[index].quantity -= 1;
        setShoppingCart(shoppingCartNext);
        setGoodsList(goodsListNext);
        SyncShoppingCart(shoppingCartNext);
      } else {
        console.log("Product is already only one");
      }
    } else {
      console.log("Product is not in shoppingcart");
    }
  }


  return (
    <>       
      <ScrollToTop />
      <Header 
        setAuthToken={setAuthToken} 
        appUserName={appUserName} 
        setAppUserName={setAppUserName}
        addedGoods={shoppingCart.added_products}
      />   
      <div className="row plato">
        <div className="col-2 fixed-top vh-100 p-0 left-panel-wrapper">
          <SideBar
            addedGoods={shoppingCart.added_products}
            years={userYears}
            currentYear={currentYear}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
          />
        </div>
        <div className="col-2">
        </div>
        <div className="col-10 border-start px-4 pb-4 right-panel">
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              {selectedYear < currentYear ?                   
                <Route exact path="/" element={
                  <Order 
                    order={order}
                    selectedYear={selectedYear}
                  />
                }/> : 
                <>
                  <Route exact path="/" element={
                    <CatalogCategories 
                      categories={categories} 
                      goodsList={goodsList}
                      selectedYear={selectedYear}
                      //addProductClick={AddProductButtonClick}
                    />
                  }/>
                  <Route path="/category/:categoryId" element={
                    <Category 
                      categories={categories} 
                      goodsList={goodsList}
                      selectedYear={selectedYear}
                      addProductClick={AddProductButtonClick}
                    />
                  }/>
                </>
              }
              <Route path="/product/:productId" element={
                <Product 
                  goodsList={goodsList}
                  selectedYear={selectedYear}
                  addProductClick={AddProductButtonClick}
                />
              }/>                
              <Route path="/shopping_cart" element={
                <ShoppingCart 
                  addedProducts={shoppingCart.added_products}
                  goodsList={goodsList}
                  selectedYear={selectedYear}
                  removeProductClick={RemoveProductButtonClick}
                  IncreaseProductCountClick={IncreaseProductCountButtonClick}
                  DecreaseProductCountClick={DecreaseProductCountButtonClick}
                  order={order.ordered_products}
                />
              }/>
              <Route path="/order" element={
                <Order 
                  order={order}
                  selectedYear={selectedYear}
                />
              }/>
              <Route path="send_contract" element={
                <SendContract
                  order={order} 
                  selectedYear={selectedYear}
                />
              }/>    
              <Route path="/profile" element={
                <Profile 
                  syncProfile={SyncProfile}
                />
              }/>      
              <Route path="/tickets" element={
                <Tickets 
                  selectedYear={selectedYear}
                />
              }/>
              <Route path="/ticket_create" element={
                <TicketCreate 
                  selectedYear={selectedYear}
                />
              }/>  
              <Route path="/ticket/:ticketId" element={
                <TicketUpdate 
                />
              }/>           
              <Route path="/task/:taskId" element={
                <FormPage
                  formMode="lab"
                  taskUrl="/form_task/"
                />
              }/>
              <Route path="/task_list" element={
                <TasksList
                  selectedYear={selectedYear}
                />
              }/>
              <Route path="/task_calendar" element={
                <TasksCalendar
                  selectedYear={selectedYear}
                />
              }/>                                
            </Routes>
          </Suspense>
        </div>
      </div>
    </>
  );  
}

export default ProtectedPages